// ---------------------------------------------------------------------------
// Mobile-app reference dimensions for the branding preview + overflow warning
// ---------------------------------------------------------------------------
// Mirrors sidekick-app (BrandBanner.tsx, ChannelSplash.tsx, theme/typography.ts).
// Calibrated for iPhone SE -- smallest supported, so warnings stay conservative.
// Keep in sync manually when mobile changes typography or layout.

export const MIN_SUPPORTED_SCREEN_WIDTH = 375
export const MIN_SUPPORTED_SCREEN_HEIGHT = 667 // iPhone SE

// ---- Banner ---------------------------------------------------------------

export const MOBILE_BANNER_FONT_FAMILY = 'Figtree, sans-serif'
export const MOBILE_BANNER_TITLE_FONT_SIZE = 15
export const MOBILE_BANNER_SUBTITLE_FONT_SIZE = 11
export const MOBILE_BANNER_TITLE_LETTER_SPACING = 0.8
export const MOBILE_BANNER_SUBTITLE_LETTER_SPACING = 0.5

// Pill width at iPhone SE (375): 247px.
//   with image:    247 - avatar(56) - gap(8) - padding(8 x2) = 167
//   without image: 247 - padding(8 x2) = 231
export const MOBILE_BANNER_TEXT_WIDTH_WITH_IMAGE = 167
export const MOBILE_BANNER_TEXT_WIDTH_NO_IMAGE = 231

// ---- Splash ---------------------------------------------------------------

// Splash uses the RN system default font (SF on iOS, Roboto on Android).
export const MOBILE_SPLASH_FONT_FAMILY = 'system-ui, -apple-system, sans-serif'
export const MOBILE_SPLASH_TITLE_FONT_SIZE = 16
export const MOBILE_SPLASH_SUBTITLE_FONT_SIZE = 12
export const MOBILE_SPLASH_TITLE_LETTER_SPACING = 1
export const MOBILE_SPLASH_SUBTITLE_LETTER_SPACING = 0.5
export const MOBILE_SPLASH_LINE_HEIGHT = 1.2
export const MOBILE_SPLASH_OUTER_PADDING_X = 40
export const MOBILE_SPLASH_TEXT_PADDING_X = 16
export const MOBILE_SPLASH_IMAGE_SIZE = 128
export const MOBILE_SPLASH_GAP = 16
export const MOBILE_SPLASH_TEXT_WIDTH =
  MIN_SUPPORTED_SCREEN_WIDTH - MOBILE_SPLASH_OUTER_PADDING_X * 2 - MOBILE_SPLASH_TEXT_PADDING_X * 2 // 263

// Matches mobile's <Text numberOfLines={2}> on the splash. Warning fires on any wrap.
export const MOBILE_SPLASH_MAX_LINES = 2

export const SPLASH_PREVIEW_MAX_WIDTH = 270

// ---- Warning copy ---------------------------------------------------------

export function getOverflowWarning(
  overflow: { banner: boolean; splash: boolean },
  noun: 'name' | 'subtitle',
): string | null {
  if (overflow.banner || overflow.splash)
    return `On smaller devices, this ${noun} may be cut off or wrap onto a second line in the app.`
  return null
}
